/** Phase 7A / Wave 1 B02 — SCR-BIZ-001–004 Business Account sign-up bindings (07-02). */

export const SIGNUP_SETUP_SCREEN_IDS = [
  'SCR-BIZ-001',
  'SCR-BIZ-002',
  'SCR-BIZ-003',
  'SCR-BIZ-004',
] as const;

export type SignupSetupScreenId = (typeof SIGNUP_SETUP_SCREEN_IDS)[number];

export const SIGNUP_SETUP_ROUTES: Record<SignupSetupScreenId, string> = {
  'SCR-BIZ-001': '/corporate-sign-up',
  'SCR-BIZ-002': '/account-verification',
  'SCR-BIZ-003': '/setup-checklist',
  'SCR-BIZ-004': '/account-overview',
};

export const SIGNUP_SETUP_PERMISSIONS: Partial<Record<SignupSetupScreenId, readonly string[]>> = {
  'SCR-BIZ-002': ['PERM-corporate.account.update'],
  'SCR-BIZ-003': ['PERM-corporate.account.read'],
  'SCR-BIZ-004': ['PERM-corporate.account.read'],
};

/** Closest documented + SDK operations. 10-06 Part 2 lists GET/PATCH /account only. */
export const SIGNUP_SETUP_ENDPOINTS: Partial<Record<SignupSetupScreenId, readonly string[]>> = {
  'SCR-BIZ-001': ['POST /business/v1/accounts', 'PATCH /business/v1/account'],
  'SCR-BIZ-002': [
    'GET /business/v1/account',
    'GET /business/v1/account/verification',
    'POST /business/v1/account/verification/evidence',
  ],
  'SCR-BIZ-003': [
    'GET /business/v1/account/setup-checklist',
    'GET /business/v1/account',
    'POST /business/v1/account/go-live',
  ],
  'SCR-BIZ-004': [
    'GET /business/v1/account',
    'GET /business/v1/approvals',
    'GET /business/v1/invoices',
    'GET /business/v1/budgets',
    'GET /business/v1/budgets/{id}/consumption',
  ],
};

export const SETUP_CHECKLIST_STEPS = [
  {
    code: 'account-verification',
    label: 'Account verification',
    route: '/account-verification',
    screenId: 'SCR-BIZ-002',
    optional: false,
  },
  {
    code: 'organisation-setup',
    label: 'Organisation setup',
    route: '/department-list',
    screenId: 'SCR-BIZ-005',
    optional: true,
  },
  {
    code: 'policies',
    label: 'Spending policies',
    route: '/policy-list',
    screenId: 'SCR-BIZ-013',
    optional: false,
  },
  {
    code: 'employees',
    label: 'Invite employees',
    route: '/invite-employees',
    screenId: 'SCR-BIZ-010',
    optional: true,
  },
  {
    code: 'budget',
    label: 'Create a budget',
    route: '/budget-monitor',
    screenId: 'SCR-BIZ-020',
    optional: true,
  },
  {
    code: 'billing-contact',
    label: 'Billing contact',
    route: '/account-settings',
    screenId: 'SCR-BIZ-028',
    optional: false,
  },
  {
    code: 'go-live',
    label: 'Go live',
    route: '/setup-checklist',
    screenId: 'SCR-BIZ-003',
    optional: false,
  },
] as const;

/** Backend required types (MOD-027). Extra types remain uploadable. */
export const VERIFICATION_REQUIRED_EVIDENCE_TYPES = [
  'CERTIFICATE_OF_INCORPORATION',
  'BANK_STATEMENT',
] as const;

export const VERIFICATION_EVIDENCE_TYPES = [
  ...VERIFICATION_REQUIRED_EVIDENCE_TYPES,
  'UTILITY_BILL',
  'DIRECTOR_ID',
] as const;

/** 07-02 realtime ○ for SCR-BIZ-002 and SCR-BIZ-004. */
export const SIGNUP_SETUP_POLL_MS = 15_000;

export const ACCOUNT_ID_STORAGE_KEY = 'beatq.business.accountId';

export const OVERVIEW_APPROVAL_PERM = 'PERM-approval.request.read';
export const OVERVIEW_SPEND_PERM = 'PERM-corporate.spend.read';
export const OVERVIEW_INVOICE_PERM = 'PERM-invoice.invoice.read';
